import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e01d6bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseProfileCreation',
  props: {
    id: {},
    image: {},
    date: {},
    price: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: `/work?id=${_ctx.id}`,
    class: "profile-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.image,
        class: "profile-card__image"
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})